import { render, staticRenderFns } from "./ProjectVideoDialog.vue?vue&type=template&id=51157790&scoped=true&"
import script from "./ProjectVideoDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVideoDialog.vue?vue&type=style&index=0&id=51157790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51157790",
  null
  
)

export default component.exports